// When a guest is asked to save their progress. Derived from progress on
// read, never stored, like due-ness and the tree.

import type { GameState } from "../state.ts";

export type GuestWall = "none" | "soft" | "hard";

/**
 * `gate` is the unit a guest cannot reach without an account — the second
 * one, so a guest gets through the whole of unit 1, checkpoint included.
 * Passed in rather than imported: progress/ does not read the course.
 */
export function guestWall(
	guest: boolean,
	st: Pick<GameState, "unlocked">,
	gate: string | undefined,
): GuestWall {
	if (!guest) return "none";
	return gate && st.unlocked[gate] ? "hard" : "soft";
}

export type SavePrompt = "hidden" | "dismissible" | "blocking";

export function savePrompt(o: {
	wall: GuestWall;
	inLesson: boolean;
	/** A result is on screen and this guest has not dismissed the prompt for it. */
	resultPending: boolean;
	/** The guest asked for it, from the account page. */
	opened: boolean;
}): SavePrompt {
	if (o.wall === "none" || o.inLesson) return "hidden";
	if (o.wall === "hard") return "blocking";
	return o.opened || o.resultPending ? "dismissible" : "hidden";
}
